import { render } from "./StudiesUploadSecondStep.vue?vue&type=template&id=2a28c97e&scoped=true"
import script from "./StudiesUploadSecondStep.vue?vue&type=script&lang=js"
export * from "./StudiesUploadSecondStep.vue?vue&type=script&lang=js"

import "./StudiesUploadSecondStep.vue?vue&type=style&index=0&id=2a28c97e&lang=scss&scoped=true"
import "./StudiesUploadSecondStep.vue?vue&type=style&index=1&id=2a28c97e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a28c97e"]])

export default __exports__